import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useMarketingUIContext } from "../MarketingUIContext";
import { fetchMarketingBanners, fetchSingleMarketingBanner, deleteMarketingBanner } from "../../../actions/banners/banners";
import { useSnackbar } from "notistack";

export function BannerDeleteDialog({ show, onHide, id }) {
  
  // Products UI Context
  const marketingUIContext = useMarketingUIContext();
  const marketingUIProps = useMemo(() => {
    return {
      ids: id,
      queryParams: marketingUIContext.queryParams,
      setQueryParams: marketingUIContext.setQueryParams,
    };
  }, [marketingUIContext, id]);

  // Products Redux state
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();
  
  const { banner_name } = useSelector(
    (state) => ({ banner_name: id ? state.banners?.marketingbannerForEdit : undefined }),
    shallowEqual
  );

  // if there weren't selected products we should close modal
  useEffect(() => {
    if (!marketingUIProps.ids || marketingUIProps.ids.length === 0) {
      onHide();
    } else {
      dispatch(fetchSingleMarketingBanner(marketingUIProps.ids));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, marketingUIProps.ids]);

  const deleteBanner = () => {
    // server request for deleting product by seleted ids
    enableLoading();
    dispatch(deleteMarketingBanner(id)).then(async (data) => {
      
      onHide();

      await dispatch(fetchMarketingBanners(marketingUIProps.queryParams));

      await enqueueSnackbar('Banner deleted successfully', {
        variant: "success",
        autoHideDuration: 4500,
      });

      disableLoading();
    });
  };

  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'>
      {loading}
      <Modal.Header closeButton>
        <Modal.Title id='example-modal-sizes-title-lg'>
          Marketing Banner Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loading && (
          <span>Are you sure you want to remove <strong>{banner_name && banner_name.b_name}</strong> banner?</span>
        )}
        {loading && <span>Please wait, Marketing Banner is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'>
            Cancel
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteBanner}
            className='btn btn-primary btn-elevate'
            disabled={loading ? true : false}>
            Delete
            {loading && (
              <span className='ml-3 spinner px-2 spinner-white'></span>
            )}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
